import React from 'react';
import PropTypes from 'prop-types';
import Divider from '@material-ui/core/Divider';
import { FormattedMessage } from 'react-intl';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import { connect } from 'react-redux';
import Modal from '../../components/Modal';
import ModalButtons from '../../components/ModalButtons';
import { propTypes as i18nPropTypes } from '../../../hocs/intlEquipped';
import InvoiceDetails from '../../../components/Invoices/InvoiceDetails';
import { TextButton } from '../../../components/Buttons';
import { actions as modalsActions } from '../../../redux/modals';
import { INVOICES } from '../../types';
import { BffFetchContainer } from '../../../containers/FetchContainer';
import Error from '../../../components/Error';
import ModalHeader from '../../components/ModalHeader';

const InvoiceDetailsModal = ({ showModal, showInvoicesList, onClose, theme, invoiceNumber, subscriptionId, i18n }) => {
    const { formatMessage } = i18n;
    const endpoint = `/invoices/${invoiceNumber}`;

    const renderError = onClickHandlers => (
        <Error
            inline
            onClickHandlers={{
                ...onClickHandlers,
                cancel: onClose,
            }}
        />
    );

    return (
        <Modal
            onClose={ onClose }
            theme={ theme }
            open={ showModal }
            className={ theme.dialog }
            classes={{ paper: theme.paper }}
        >
            <ModalHeader
                title={ formatMessage('modals.invoiceDetails.header', { number: invoiceNumber }) }
                className={ theme.header }
                onClose={ onClose }
            />
            <div className={ theme.invoiceDetailsModal }>
                <BffFetchContainer endpoint={ endpoint } renderError={ renderError } theme={ theme }>
                    { data => (
                        <InvoiceDetails invoice={ data } theme={ theme } />
                    ) }
                </BffFetchContainer>
            </div>
            <Divider className={ theme.divider } />
            <ModalButtons className={ theme.buttons }>
                <TextButton theme={ theme.buttonBack } onClick={ () => showInvoicesList(subscriptionId) }>
                    <ArrowBackIcon />
                    <FormattedMessage id="modals.invoiceDetails.buttons.back" />
                </TextButton>
                <TextButton theme={ theme.buttonClose } onClick={ onClose }>
                    <FormattedMessage id="modals.invoiceDetails.buttons.close" />
                </TextButton>
            </ModalButtons>
        </Modal>
    );
};

InvoiceDetailsModal.propTypes = {
    showInvoicesList: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
    theme: PropTypes.shape({}),
    invoiceNumber: PropTypes.string.isRequired,
    subscriptionId: PropTypes.string,
    showModal: PropTypes.bool.isRequired,
    i18n: i18nPropTypes,
};

const mapDispatchToProps = dispatch => ({
    showInvoicesList: subscriptionId => dispatch(modalsActions.showModal(INVOICES, { subscriptionId })),
});

export default connect(null, mapDispatchToProps)(InvoiceDetailsModal);
